import React from 'react';

// The customer's shop, in the sidebar Switch Shop colours. Internal cases have no shop.
const ShopBadge = ({ shop }) => {
  if (!shop) return <span className="text-gray-300">—</span>;
  const cls = shop === 'tama' ? 'bg-yellow-800' : 'bg-indigo-700';
  return <span className={`${cls} text-white text-xs px-2 py-0.5 rounded-full font-medium`}>{shop}</span>;
};

export default ShopBadge;
